import { render, staticRenderFns } from "./CreateEditOrganization.vue?vue&type=template&id=0464fd40&scoped=true&"
import script from "./CreateEditOrganization.vue?vue&type=script&lang=js&"
export * from "./CreateEditOrganization.vue?vue&type=script&lang=js&"
import style0 from "./CreateEditOrganization.vue?vue&type=style&index=0&id=0464fd40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0464fd40",
  null
  
)

export default component.exports